export default __webpack_public_path__ + "static/media/fsplus-delivery-installation.3632ba00.png";